/**
 * Owner: Masa Bayu
 * File: fills-column.ts
 * Date:Time: 2026-10-13 23:23
 * Description: Geometry-only fillsColumn · A5 Option A · shared justify SoT.
 */

import type { LineInput } from '../types.js';

export type { LineInput };

/**
 * Body column fill threshold (ratio of column width).
 * Proven A5 · Option A · aligns tip with Edit (no columnIds OR).
 */
export const BODY_COLUMN_JUSTIFY_RATIO = 0.9;

/**
 * True when the line should receive text-align: justify.
 * Geometry only: reachesRight OR ratio ≥ BODY_COLUMN_JUSTIFY_RATIO.
 * Source migration: apps/qxread/src/profile/spsu-native-line-justify.ts (Fasa A5).
 */
export function fillsColumn(line: LineInput): boolean {
  return line.reachesRight || line.ratio >= BODY_COLUMN_JUSTIFY_RATIO;
}
